class OnAvailable {
	constructor(root) {
		this.root = root || window.document.documentElement;
		this.listeners = [];
	}

	ready(selector, fn) {
		// Store the selector and callback to be monitored
		this.listeners.push({
			selector: selector,
			fn: fn,
		});

		if (!this.observer) {
			// Watch for changes in the document
			this.observer = onChange(this.root, this.check.bind(this), {
				childList: true,
				subtree: true,
			});
		}
		// Check if the element is currently in the DOM
		this.check();
	}

	check() {

		const listnersSelectorsArray = [];
		Array.from(this.listeners).forEach((listener) => {
			listnersSelectorsArray.push(listener.selector);
		});
		const listnersSelectors = listnersSelectorsArray.join(",");
		const matchingElements = this.root.querySelectorAll(listnersSelectors);
		// Check the DOM for elements matching a stored selector

		Array.from(matchingElements).forEach((element) => {

			Array.from(this.listeners).forEach((listener) => {
				const attributeName = listener.selector.substring(1, listener.selector.length - 1);
				if (element.hasAttribute(attributeName) && !element[attributeName]) {
					listener.fn.call(element, element);
					element[attributeName] = true;
				}
			});
		});

	}
}

export const onAvailable = new OnAvailable(window.document.documentElement);

export function onChange(element, fn, options) {
	const MutationObserver =
		window.MutationObserver || window.WebKitMutationObserver;
	const observer = new MutationObserver(fn);
	observer.observe(
		element,
		options || {
			attributes: true,
			childList: true,
			subtree: true,
		}
	);
	return observer;
}



// WEBPACK FOOTER //
// ./client/src/core/lib/on-available.js